function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 15 16"
}, props), React.createElement("path", {
  d: "M4.535 3.3h-2.35C1.393 3.3.75 3.942.75 4.735v0c0 .794.643 1.437 1.437 1.437h2.35M10.305 3.3h2.35c.793 0 1.437.643 1.437 1.436v0c0 .794-.644 1.437-1.437 1.437h-2.35",
  stroke: "#fff"
}), React.createElement("path", {
  d: "M1.854 14.5v.974h11.132V14.5h-.253a4.605 4.605 0 01-4.607-4.604H6.712a4.605 4.605 0 01-4.605 4.604h-.253z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M7.441 9.926a3.95 3.95 0 01-3.896-3.298L2.885.903h9.111l-.661 5.725A3.95 3.95 0 017.44 9.926z",
  fill: "#fff"
})));